<template>
  <div class="gonetwork1">
    <el-container>
      <!-- 页头 -->
      <el-header>
        <div class="maintitle">
          <img src="../../assets/img/gonetworkicon.png" @click="gonetwork0" />
          <div @click="gonetwork0">首页</div>
          <div class="active" @click="gonetwork1">产品介绍</div>
          <div @click="gonetwork2">功能介绍</div>
          <div @click="gonetwork3">下载</div>
        </div>
      </el-header>
      <!-- 主体内容 -->
      <el-main>
        <div class="gonetworkmain"></div>
        <div class="gonetworktol">
          <div class="toldiv">
            <img src="../../assets/img/gonetworktol1.png" />
            <div class="tolinfo">
              <img src="../../assets/img/gonetworktol2.png" />
              <div>
                去上网APP是一款以方便网民、简化上网流程、降低场所经营成本为理念所开发的移动APP，为网民提供便捷、安全、有效的上网方式。
              </div>
            </div>
          </div>
        </div>
        <div class="gonetworksj">
          <div class="sjtitle">简单三步&nbsp;&nbsp;&nbsp;超神上机</div>
          <div class="sjinfo">
            <div class="sjcard">
              <img src="../../assets/img/gonetworksj1.png" />
              <div>身份证认证</div>
            </div>
            <img class="sjcardimg" src="../../assets/img/gonetworksj4.png" />
            <div class="sjcard">
              <img src="../../assets/img/gonetworksj2.png" />
              <div>扫描上机二维码</div>
            </div>
            <img class="sjcardimg" src="../../assets/img/gonetworksj4.png" />
            <div class="sjcard">
              <img src="../../assets/img/gonetworksj3.png" />
              <div>开始上机</div>
            </div>
          </div>
        </div>
        <div class="gonetworkys">
          <div class="ystitle">产品优势</div>
          <div class="ysinfo">
            <div class="ysicon">
              <img src="../../assets/img/gonetwork1_1.png" />
              <div class="tal">针对网吧</div>
              <div class="tel">
                安全确保用户真实信息<br />紧跟互联网时代，增加上网渠道<br />提升网吧逼格，增加客流量
              </div>
            </div>
            <div class="ysicon">
              <img src="../../assets/img/gonetwork1_2.png" />
              <div class="tal">针对网民</div>
              <div class="tel">
                人脸识别，一键扫码上机<br />安全、有效、便民、利民
              </div>
            </div>
            <div class="ysicon">
              <img src="../../assets/img/gonetwork1_3.png" />
              <div class="tal">针对网监</div>
              <div class="tel">
                采用阿里云人脸识别技术<br />提供真实有效用户信息<br />快捷化管理
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <!-- 底部 -->
      <el-footer>
        <div class="fotter">
          <div class="fotterdiv">
            <div class="yuedong">
              <img src="../../assets/img/gonetworkfooter.png" />
              <div class="text1">
                © Copyright {{currentYear}} yedone.com all rights reserved.
                渝网文[2013]0887-006号
              </div>
              <div class="text2">
                经营许可证：渝B2-20190234&nbsp;&nbsp;|&nbsp;&nbsp;<span @click="zhizhao">营业执照</span><br />渝ICP备09014244号-16
              </div>
              <div class="text3">
                <img src="../../assets/img/guohui.png" />
                <div class="text3tel" @click="beian">
                  渝公网安备 50010802002169号
                </div>
              </div>
            </div>
            <div class="bor">
              <div class="bor1"></div>
              <div class="bor2"></div>
            </div>
            <div class="contactUs">
              <div class="women">联系我们</div>
              <div class="phone">
                <div class="dianhua1">
                  <div>客服电话（24h）</div>
                  <div>400-680-8811</div>
                </div>
                <div class="dianhua2">
                  <div>商务电话（工作日09:00-18:00)</div>
                  <div>023-68636622</div>
                </div>
              </div>
              <div class="phone2">
                <div class="dianhua1">
                  <div>客服QQ（24h）</div>
                  <div>4006808811</div>
                </div>
                <div class="dianhua2">
                  <div>公司地址</div>
                  <div>重庆市南岸区南城大道199号正联大厦3楼</div>
                </div>
              </div>
            </div>
            <div class="attention">
              <div class="women">关注我们</div>
              <div class="erweima">
                <div class="fuwu">
                  <img src="../../assets/img/qushangwang.png" />
                  <div>去上网APP微信服务号</div>
                </div>
                <div class="gongzong">
                  <img src="../../assets/img/baquan.jpg" />
                  <div>8圈计费微信公众号</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "gonetwork1",
  data() {
    return {};
  },
  methods: {
    //跳转首页
    gonetwork0() {
      this.$router.push("/gonetwork0");
    },
    //跳转产品介绍
    gonetwork1() {
      this.$router.push("/gonetwork1");
    },
    //跳转功能介绍
    gonetwork2() {
      this.$router.push("/gonetwork2");
    },
    //跳转下载
    gonetwork3() {
      this.$router.push("/gonetwork3");
    },
    //跳转备案
    beian() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010802002169"
      );
    },
    //跳转营业执照
    zhizhao(){
      let routeData = this.$router.resolve('/yinye');
      window.open(routeData.href, '_blank');
    }
  },
  mounted() {
    if (
      /Android|webOS|iPhone|iPod|BlackBerry|Harmony/i.test(navigator.userAgent)
    ) {
      //移动设备打开的网页，缩放页面尺寸
      /*
  		var clientWidth = document.body.clientWidth;
  		var rate = clientWidth / 1920;
  		*/
      var rate = 0.1;
      var meta = document.getElementsByTagName("meta");
      meta["viewport"].setAttribute(
        "content",
        "width=device-width,initial-scale=" + rate
      );
    }
  },  
  // 获取当前年份
  computed:{
    currentYear(){
      return new Date().getFullYear();
    }
  },
};
</script>
<style lang="less" scoped>
/* 页头样式 */
.el-header {
  width: 100%;
  min-width: 1200px;
  height: 80px !important;
  box-sizing: border-box;
  padding: 16px 0 0;
  margin: 0 auto;
  .maintitle {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
    > img {
      width: 140px;
      height: 40px;
      margin-right: 50px;
      &:hover {
        cursor: pointer;
      }
    }
    > div {
      width: 72px;
      height: 27px;
      text-align: center;
      font-size: 18px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      line-height: 27px;
      color: #666666;
      margin-left: 80px;
      &:hover {
        cursor: pointer;
      }
    }
    .active {
      opacity: 1;
      position: relative;
      color: #ff6c00;
      &::after {
        content: "";
        position: absolute;
        width: 30px;
        height: 4px;
        background: #ff6c00;
        opacity: 1;
        bottom: -10px;
        left: 50%;
        transform: translate(-50%, 50%);
      }
    }
  }
}
.el-main {
  width: 100%;
  min-width: 1200px;
  padding: 0;
  margin: 0 auto;
  .gonetworkmain {
    margin: 0 auto;
    height: 640px;
    background-image: url(../../assets/img/gonetwork1back.png);
    background-size: cover;
    /* 将背景图片等比缩放填满整个容器 */
    background-repeat: no-repeat;
    background-position: center;
  }
  .gonetworktol {
    height: 600px;
    box-sizing: border-box;
    padding-top: 60px;
    .toldiv {
      width: 1200px;
      height: 480px;
      margin: 0 auto;
      display: flex;
      .tolinfo {
        width: 520px;
        margin: 40px 0 0 180px;
        > div {
          width: 520px;
          height: 273px;
          font-size: 36px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          line-height: 54px;
          color: #2d394b;
          margin-top: 20px;
        }
      }
    }
  }
  .gonetworksj {
    height: 580px;
    background-image: url(../../assets/img/gonetworksjback.png);
    background-size: cover;
    /* 将背景图片等比缩放填满整个容器 */
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding-top: 112px;
    .sjtitle {
      width: 805px;
      height: 54px;
      font-size: 36px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 54px;
      color: #ffffff;
      margin: 0 auto;
      text-align: center;
    }
    .sjinfo {
      width: 1088px;
      height: 236px;
      display: flex;
      margin: 60px auto 0;
      .sjcard {
        text-align: center;
        > div {
          height: 36px;
          font-size: 24px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          line-height: 36px;
          color: #ffffff;
          opacity: 0.8;
          margin: 20px auto 0;
        }
      }
      .sjcardimg {
        width: 55.97px;
        height: 16.97px;
        margin: 64px 109px 0;
      }
    }
  }
  .gonetworkys {
    padding: 80px 0;
    .ystitle {
      width: 805px;
      height: 54px;
      font-size: 36px;
      font-family: Source Han Sans SC-Bold, Source Han Sans SC;
      font-weight: bold;
      color: #2d394b;
      margin: 0 auto;
      text-align: center;
    }
    .ysinfo {
      width: 1200px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
      .ysicon {
        width: 300px;
        > img {
          width: 300px;
          height: 200px;
        }
        .tal {
          width: 96px;
          height: 36px;
          font-size: 24px;
          font-family: Source Han Sans SC-Medium, Source Han Sans SC;
          font-weight: 500;
          color: #2d394b;
          margin: 18px auto 10px;
        }
        .tel {
          font-size: 18px;
          font-family: Source Han Sans SC-Regular, Source Han Sans SC;
          font-weight: 400;
          color: #626778;
          line-height: 27px;
          text-align: center;
        }
      }
    }
  }
}
/* 底部 */
.el-footer {
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  padding: 0;
  .fotter {
    height: 338px;
    background: #0b192b;
    padding-top: 51px;
    box-sizing: border-box;
    .fotterdiv {
      width: 1200px;
      height: 225px;
      margin: 0 auto;
      display: flex;
      .yuedong {
        width: 273px;
        height: 225px;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 21px;
        color: #626778;
        > img {
          width: 140px;
          height: 40px;
        }
        .text1 {
          margin-top: 47px;
        }
        .text2 {
          margin-top: 14px;
          span:hover{cursor: pointer;color: #ffffff;}
        }
        .text3 {
          margin-top: 14px;
          display: flex;
          justify-items: center;
          img {
            margin-right: 10px;
          }
          .text3tel {
            &:hover {
              cursor: pointer;
              color: #ffffff;
            }
          }
        }
      }
      .bor {
        width: 1px;
        height: 225px;
        margin-left: 36px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .bor1 {
          flex: 1;
        }
        .bor2 {
          height: 120px;
          border: 1px solid #1b2c43;
        }
      }
      .contactUs {
        width: 475px;
        height: 218px;
        margin-left: 50px;
        margin-top: 9px;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        line-height: 18px;
        color: #ffffff;
        .women {
          width: 80px;
          height: 29px;
        }
        .phone,
        .phone2 {
          margin-top: 57px;
          display: flex;
          .dianhua1,
          .dianhua2 {
            div:nth-child(1) {
              height: 20px;
              font-size: 14px;
              font-weight: 400;
              color: #626778;
            }
            div:nth-child(2) {
              height: 22px;
              font-size: 18px;
              font-family: DIN;
              color: #ffffff;
              margin-top: 8px;
            }
          }
          .dianhua1 {
            width: 124px;
          }
          .dianhua2 {
            margin-left: 52px;
          }
        }
        .phone2 {
          margin-top: 30px;
          .dianhua2 div:nth-child(2) {
            font-family: Source Han Sans SC;
            font-size: 16px;
          }
        }
      }
      .attention {
        width: 298px;
        height: 218px;
        margin-left: 67px;
        margin-top: 9px;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        line-height: 18px;
        color: #ffffff;
        .women {
          width: 80px;
          height: 29px;
          margin-left: 10px;
        }
        .erweima {
          display: flex;
          margin-top: 51px;
          .fuwu,
          .gongzong {
            font-size: 14px;
            font-weight: 400;
            color: #626778;
            text-align: center;
            > img {
              width: 110px;
              height: 110px;
            }
            > div {
              margin-top: 8px;
            }
          }
          .gongzong {
            margin-left: 38px;
          }
        }
      }
    }
  }
}
</style>
